// 9fbef606107a605d69c0edbcd8029e5d
import React from 'react';
import PropTypes from 'prop-types';
import Image from '@tcp/core/src/components/common/atoms/Image';
import { getIconPath } from '@tcp/core/src/utils';
import ModalCloseIcon from './ModalCloseIcon';
import { BodyCopy } from '../../../../../../styles/themes/TCP/typotheme';
import SafeComponent from '../../../hoc/withErrorBoundary/errorBoundary';

const ModalHeader = ({
  closeFunc,
  heading,
  closeIconDataLocator,
  headingStyle,
  closeIconLeftAligned,
  dataLocatorHeader,
  inheritedStyles,
  hideCloseButton,
  isBackButtonShow,
  isBackToQuickViewButtonShow,
}) => {
  return (
    <div className="Modal-Header">
      <ModalCloseIcon
        className="close-modal"
        closeFunc={closeFunc}
        closeIconDataLocator={closeIconDataLocator}
        closeIconLeftAligned={closeIconLeftAligned}
        inheritedStyles={inheritedStyles}
        hideCloseButton={hideCloseButton}
      />
      {isBackToQuickViewButtonShow && (
        <button
          type="button"
          className="back-to-qv-button-wrapper"
          onClick={(e) => closeFunc(e, true)}
        >
          <Image
            src={getIconPath('carrot-left-light-gray')}
            className="back-to-qv-button-left-arrow"
            alt=""
          />
        </button>
      )}
      {heading && (
        <BodyCopy data-locator={dataLocatorHeader} {...headingStyle}>
          {heading}
        </BodyCopy>
      )}

      {isBackButtonShow && (
        <BodyCopy className="back-button" component="span" onClick={(e) => closeFunc(e)} />
      )}
    </div>
  );
};

ModalHeader.propTypes = {
  closeFunc: PropTypes.func.isRequired,
  heading: PropTypes.string.isRequired,
  closeIconDataLocator: PropTypes.string.isRequired,
  headingStyle: PropTypes.string,
  closeIconLeftAligned: PropTypes.bool.isRequired,
  dataLocatorHeader: PropTypes.string.isRequired,
  inheritedStyles: PropTypes.string.isRequired,
  hideCloseButton: PropTypes.bool,
};

ModalHeader.defaultProps = {
  headingStyle: {
    bodySize: 'five',
    fontWeight: 'black',
    tag: 'h2',
    className: 'Modal_Heading',
  },
  hideCloseButton: false,
};

export default SafeComponent(ModalHeader);
